var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"form-check\">\n  <input class=\"custom form-check-input\" type=\"checkbox\" id=\"custom\">\n  <label class=\"form-check-label\" for=\"custom\">\n    Custom?\n  </label>\n</div>\n<textarea class=\"form-control custom-input\" rows=\"3\"></textarea>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/edit_mode/_custom.hbs
// module id = 136
// module chunks = 0